import React, { memo } from 'react';
import Container from '../../atoms/Container';
import Header from '../../atoms/Header';
import Checklist from './checklist';
import { Wrapper } from './components';
import { purify } from '../../utils/helpers';
export function Checklists({ container, header, data, footer, }) {
    return (React.createElement(Container, Object.assign({}, container),
        header && React.createElement(Header, Object.assign({}, header)),
        React.createElement(Wrapper, null, data &&
            data.map((checklist, i) => (React.createElement(Checklist, Object.assign({}, checklist, { key: `checklist-${i}`, hasMultiple: data.length > 1 }))))),
        footer && (React.createElement("footer", { dangerouslySetInnerHTML: { __html: purify(footer) } }))));
}
export default memo(Checklists);
//# sourceMappingURL=checklists.js.map